import {useEffect, useRef} from 'react'
import {useCustomerType} from '@salesforce/commerce-sdk-react'
import {trackOptimizelyEvent} from '../utils/optimizely-event'

/*
 * login_success / logout_success when the stored customer type flips between
 * guest and registered. The first non-null read is the page-load state.
 */
export function useOptimizelyExpAuth() {
    const {customerType} = useCustomerType()
    const previousType = useRef(null)

    useEffect(() => {
        if (customerType !== 'guest' && customerType !== 'registered') return
        const previous = previousType.current
        previousType.current = customerType
        if (!previous || previous === customerType) return
        trackOptimizelyEvent({
            eventName: customerType === 'registered' ? 'login_success' : 'logout_success',
            tags: null,
            properties: {URL: window.location.href}
        })
    }, [customerType])
}
